import { PERMISSIONS } from './permissions'

export interface MenuItem {
  key: string
  label: string
  path?: string
  icon?: string
  permission?: string
  children?: MenuItem[]
}

export const menuConfig: MenuItem[] = [
  {
    key: 'home',
    label: '首页',
    path: '/home',
    icon: 'HomeFilled',
  },
  {
    key: 'processing',
    label: '加工管理',
    icon: 'Operation',
    permission: PERMISSIONS.PROCESSING.TASK.VIEW,
    children: [
      {
        key: 'grp-task',
        label: '任务中心',
        children: [
          {
            key: 'task-center',
            label: '任务总览',
            path: '/processing/task-center',
            icon: 'DataBoard',
          },
          {
            key: 'task-management',
            label: '任务调度',
            path: '/processing/task-management',
            icon: 'List',
          },
        ],
      },
      {
        key: 'grp-apply',
        label: '申请与排程',
        children: [
          {
            key: 'mold-initial-list',
            label: '模具初始列表',
            path: '/processing/mold-initial-list',
            icon: 'Folder',
          },
          {
            key: 'application',
            label: '加工申请',
            path: '/processing/application',
            icon: 'DocumentAdd',
          },
          {
            // 2026-10-18 补齐：其他工件(非模 general)领料，对齐小程序 non-mold-pickup
            key: 'non-mold-pickup',
            label: '其他工件领料',
            path: '/processing/non-mold-pickup',
            icon: 'Box',
          },
          {
            key: 'application-statistics',
            label: '申请统计',
            path: '/processing/application-statistics',
            icon: 'DataAnalysis',
          },
          {
            key: 'gantt-chart',
            label: '排程甘特图',
            path: '/processing/gantt-chart',
            icon: 'TrendCharts',
          },
          {
            key: 'schedule-history',
            label: '调整历史',
            path: '/processing/schedule-history',
            icon: 'Clock',
          },
          {
            key: 'preset',
            label: '工序预设',
            path: '/processing/preset',
            icon: 'Setting',
          },
        ],
      },
      {
        key: 'grp-basic',
        label: '基础数据',
        children: [
          {
            key: 'vendor',
            label: '供应商管理',
            path: '/processing/vendor',
            icon: 'Shop',
          },
        ],
      },
      {
        key: 'grp-special',
        label: '专项工序',
        children: [
          {
            key: 'sub-process',
            label: '备料工序管理',
            path: '/processing/sub-process',
            icon: 'Operation',
          },
          {
            key: 'prep-execution',
            label: '备料工序执行',
            path: '/processing/prep-execution',
            icon: 'VideoPlay',
          },
          {
            key: 'prep-preset',
            label: '备料工序预设',
            path: '/processing/prep-preset',
            icon: 'SetUp',
          },
          {
            key: 'guide-slot-edm',
            label: '导料槽EDM',
            path: '/processing/guide-slot-edm',
            icon: 'MagicStick',
          },
          {
            key: 'heat-treatment-batch',
            label: '委外热处理外发',
            path: '/processing/heat-treatment-batch',
            icon: 'Promotion',
          },
        ],
      },
      {
        key: 'grp-stats',
        label: '统计报表',
        children: [
          {
            key: 'equipment-oee',
            label: '设备OEE分析',
            path: '/processing/equipment-oee',
            icon: 'Odometer',
          },
          {
            key: 'person-performance',
            label: '人员绩效统计',
            path: '/processing/person-performance',
            icon: 'UserFilled',
          },
        ],
      },
    ],
  },
  {
    key: 'mold',
    label: '模库管理',
    icon: 'FolderOpened',
    children: [
      {
        key: 'list',
        label: '模具列表',
        path: '/mold/list',
        icon: 'Document',
        permission: PERMISSIONS.MOLD.LIST.VIEW,
      },
      {
        key: 'parts',
        label: '配件列表',
        path: '/mold/parts',
        icon: 'Grid',
      },
      // 🔴 2026-09-12 用户拍板：领模/还模/入库操作全在手机端做，PC端只保留查看。
      // 「入库管理」页核心是执行流程（新建入库申请/质检/审批）→ 菜单移除；路由保留（直链可达）。
      // {
      //   key: 'storage',
      //   label: '入库管理',
      //   path: '/mold/storage',
      //   icon: 'Box',
      //   permission: PERMISSIONS.MOLD.STORAGE.VIEW,
      // },
      {
        key: 'borrow-management',
        label: '领还管理',
        path: '/mold/borrow-management',
        icon: 'DocumentCopy',
        permission: PERMISSIONS.MOLD.BORROW.MODULE,
      },
      // 🔴 2026-09-12 用户拍板：领模/还模/入库操作全在手机端做，PC端只保留查看。
      // 纯执行入口（配件领用审批）从菜单移除；路由保留（直链可达），页面转纯查看。
      // {
      //   key: 'part-borrow-approval',
      //   label: '配件领用审批',
      //   path: '/mold/part-borrow-approval',
      //   icon: 'Select',
      //   permission: PERMISSIONS.MOLD.BORROW.MODULE,
      // },
      {
        key: 'my-part-borrow',
        label: '我的配件领用',
        path: '/mold/my-part-borrow',
        icon: 'User',
      },
      {
        key: 'slot-check',
        label: '槽宽检测列表',
        path: '/mold/slot-check',
        icon: 'Crop',
      },
      {
        key: 'compare',
        label: '模具对比',
        path: '/mold/compare',
        icon: 'DataAnalysis',
      },
      {
        key: 'mold-transfer',
        label: '模具交接',
        path: '/mold/mold-transfer',
        icon: 'Switch',
      },
      {
        key: 'reprocess',
        label: '模具再处理',
        path: '/mold/reprocess',
        icon: 'RefreshRight',
      },
      {
        key: 'product',
        label: '成品管理',
        path: '/mold/product',
        icon: 'Box',
        permission: PERMISSIONS.SYSTEM.PRODUCT.VIEW,
      },
      {
        key: 'meters-rank',
        label: '米数排行',
        path: '/mold/meters-rank',
        icon: 'TrendCharts',
      },
    ],
  },
  {
    key: 'tuning',
    label: '调模管理',
    icon: 'Tools',
    permission: PERMISSIONS.DEBUGGER.TASK.VIEW,
    children: [
      {
        key: 'recent-molds',
        label: '近期下模具',
        path: '/tuning/recent-molds',
        icon: 'Clock',
      },
      {
        key: 'task-list',
        label: '调模任务列表',
        path: '/tuning/task-list',
        icon: 'List',
      },
      {
        key: 'records',
        label: '调模记录',
        path: '/tuning/records',
        icon: 'Notebook',
      },
    ],
  },
  {
    key: 'forming',
    label: '成型管理',
    icon: 'Promotion',
    permission: PERMISSIONS.FORMING.TASK.VIEW,
    children: [
      // 🔴 2026-09-11 用户拍板：删除「成型主页」菜单项——主任工作台已内嵌「首页」，
      // /forming 路由保留（直链可达），但不再作为菜单暴露
      {
        key: 'match',
        label: '匹配模具',
        path: '/forming/match',
        icon: 'Search',
      },
      {
        key: 'tasks',
        label: '成型任务',
        path: '/forming/tasks',
        icon: 'List',
      },
      {
        key: 'records',
        label: '成型记录',
        path: '/mold/forming-records',
        icon: 'Notebook',
      },
    ],
  },
  {
    key: 'equipment',
    label: '设备管理',
    icon: 'Monitor',
    children: [
      {
        key: 'eq-grp-asset',
        label: '资产管理',
        children: [
          {
            key: 'list',
            label: '设备列表',
            path: '/equipment/list',
            icon: 'Monitor',
          },
          {
            key: 'workshop',
            label: '车间管理',
            path: '/equipment/workshop',
            icon: 'OfficeBuilding',
          },
        ],
      },
      {
        key: 'eq-grp-repair',
        label: '维修管理',
        children: [
          {
            key: 'repair-order',
            label: '我的报修',
            path: '/equipment/repair/order',
            icon: 'Document',
          },
          {
            key: 'repair',
            label: '维修工单',
            path: '/equipment/repair',
            icon: 'Odometer',
          },
          {
            key: 'workpoint-summary',
            label: '工分统计',
            path: '/equipment/workpoint-summary',
            icon: 'TrendCharts',
          },
        ],
      },
      {
        key: 'eq-grp-maint',
        label: '保养管理',
        children: [
          {
            key: 'maintenance',
            label: '设备检修',
            path: '/equipment/maintenance',
            icon: 'Tools',
          },
          {
            key: 'baseline-import',
            label: '保养基准导入',
            path: '/equipment/baseline-import',
            icon: 'Upload',
          },
          {
            key: 'runtime-import',
            label: '运行时长导入',
            path: '/equipment/runtime-import',
            icon: 'Odometer',
          },
          {
            key: 'annual-plan',
            label: '年度保养总计划',
            path: '/equipment/annual-plan',
            icon: 'Calendar',
          },
        ],
      },
    ],
  },
  {
    key: 'consumable',
    label: '耗材管理',
    icon: 'Box',
    children: [
      {
        key: 'list',
        label: '耗材列表',
        path: '/consumable/list',
        icon: 'List',
      },
      {
        key: 'inbound',
        label: '耗材入库',
        path: '/consumable/inbound',
        icon: 'Download',
      },
      {
        key: 'outbound',
        label: '耗材出库',
        path: '/consumable/outbound',
        icon: 'Upload',
      },
    ],
  },
  {
    key: 'performance',
    label: '绩效管理',
    icon: 'TrendCharts',
    children: [
      {
        key: 'statistics',
        label: '绩效统计',
        path: '/performance/statistics',
        icon: 'DataAnalysis',
      },
      {
        key: 'personal',
        label: '个人绩效',
        path: '/performance/personal',
        icon: 'User',
      },
      {
        key: 'team',
        label: '团队绩效',
        path: '/performance/team',
        icon: 'UserFilled',
      },
    ],
  },
  {
    key: 'system',
    label: '系统管理',
    icon: 'Setting',
    children: [
      {
        key: 'user',
        label: '用户管理',
        path: '/system/user',
        icon: 'User',
        permission: PERMISSIONS.SYSTEM.USER.VIEW,
      },
      {
        key: 'role',
        label: '角色管理',
        path: '/system/role',
        icon: 'Avatar',
        permission: PERMISSIONS.SYSTEM.ROLE.VIEW,
      },
      {
        key: 'department',
        label: '部门管理',
        path: '/system/department',
        icon: 'OfficeBuilding',
        permission: PERMISSIONS.SYSTEM.DEPARTMENT.VIEW,
      },
      {
        key: 'permission',
        label: '权限管理',
        path: '/system/permission',
        icon: 'Lock',
        permission: PERMISSIONS.SYSTEM.PERMISSION.VIEW,
      },
      {
        key: 'permission-log',
        label: '权限日志',
        path: '/system/permission-log',
        icon: 'Document',
      },
      {
        key: 'backup',
        label: '数据备份',
        path: '/system/backup',
        icon: 'FolderOpened',
      },
      {
        key: 'settings',
        label: '系统参数设置',
        path: '/system/settings',
        icon: 'Tools',
      },
      {
        key: 'notification',
        label: '消息中心',
        path: '/system/notification',
        icon: 'Bell',
      },
      {
        key: 'flow-designer',
        label: '流程设计器',
        path: '/system/flow-designer',
        icon: 'Connection',
      },
      {
        key: 'point-standard',
        label: '标准积分表管理',
        path: '/system/point-standard',
        icon: 'TrendCharts',
        permission: PERMISSIONS.SYSTEM.POINT_STANDARD.MANAGE,
      },
    ],
  },
  {
    key: 'report',
    label: '报表中心',
    icon: 'DataLine',
    children: [
      {
        key: 'processing',
        label: '加工报表',
        path: '/report/processing',
        icon: 'DataAnalysis',
      },
      {
        key: 'inventory',
        label: '库存报表',
        path: '/report/inventory',
        icon: 'Box',
      },
      {
        key: 'performance',
        label: '绩效报表',
        path: '/report/performance',
        icon: 'TrendCharts',
      },
      {
        key: 'equipment',
        label: '设备报表',
        path: '/report/equipment',
        icon: 'Monitor',
      },
    ],
  },
]
